/**
 * Bounds on a vessel's max email size, in BYTES on the wire.
 *
 * Mirrors the API's single shared constant, `MAX_EMAIL_SIZE_CEILING_BYTES` in
 * `src/util/email-chunk-plan.ts`, which bounds BOTH writers of that column:
 * `UpdateVesselEmailSizeDto` (the per-vessel PATCH) and
 * `UpdateEmailSettingsDto.floorBytes` (the fleet-wide floor the nightly job
 * writes to every vessel below it).
 *
 * Both portal inputs read from here so the Global Settings floor can never be
 * set above the per-vessel ceiling, which would leave this page's minimum
 * above its maximum. Keep in sync with the API constant by hand.
 */
export const MAX_EMAIL_SIZE_CEILING_BYTES = 50000000;

/**
 * Lower bound on the fleet-wide floor: MIN_CHUNK_SIZE_BYTES (65,536) * 2.
 * Below this no cap can produce a 7z volume the splitter will accept.
 */
export const MIN_EMAIL_SIZE_FLOOR_BYTES = 131072;
